import { useEffect, useState } from 'react';
import parse from 'html-react-parser';
import DownPaymentRequest from '@/components/customercenter-ui/components/modals/customerResult/downPaymentRequest';
import WarningIcon from '@/customercenter-ui/svgs/notifications/warning';
import { Button } from '@/customercenter-ui/ui/button';
import { mapLocaleToMeaningfulFormat } from '@/helpers/utils/i18n';
import { formatCurrency } from '@/helpers/utils/siteUtils';
import { getContentByTitle } from '../../../../../customercenter-ui/components/product/details/helpers/utils/productDataUtils';
const OrderDownPaymentPendingMessage = ({ order }: any) => {
  return (
    <section className="w-full md:max-w-[1141px]">
      <p className="pt-8 text-2xl font-bold text-black">
        {mapLocaleToMeaningfulFormat().orderPendingMessage}
        &nbsp;
        {mapLocaleToMeaningfulFormat().orderHash}
        {order?.orderNumber}
      </p>
    </section>
  );
};

const OrderDownPaymentPendingBox = ({ order, handleDownpaymentSuccess, loading, customerDetails }: any) => {
  const [downPaymentRequestOpen, setDownPaymentRequestOpen] = useState(false);
  const downPaymentAmount = order?.soaOrderDetails?.CreditStatus?.DownPaymentInfo?.downPaymentAmount ?? '0.0';
  const [orderPendingMsg, setOrderPendingMsg] = useState('');

  useEffect(() => {
    getContentByTitle('orderPendingDownPaymentMsg').then((data: any) => {
      setOrderPendingMsg(data?.htmlContentEntries?.[0]?.rich_text_and_html_editor || '');
    });
  }, []);

  return (
    <section className="mx-3 rounded-sm bg-[#FFF4E6] p-5 pb-10 shadow-md lg:mx-0">
      <section className="flex items-center  ">
        <section className="pr-3">
          <WarningIcon className="h-6 w-7" />
        </section>
        <p className="text-xl font-medium leading-7 text-black">{mapLocaleToMeaningfulFormat().downPaymentTitle}</p>
      </section>
      <section>
        {parse(orderPendingMsg)}
        {formatCurrency(downPaymentAmount)}
        <section className="my-4 flex flex-row gap-x-4">
          <Button className="bg-deepBlue text-white" onClick={() => setDownPaymentRequestOpen(true)}>
            <section className="px-6 py-3">{mapLocaleToMeaningfulFormat().makeDownPayment}</section>
          </Button>
          <Button
            className="border border-foggyGray bg-[#FFFFFF] text-black hover:bg-[#FFF]"
            onClick={() => setDownPaymentRequestOpen(true)}
          >
            <section className="px-16 py-3">{mapLocaleToMeaningfulFormat().learnMore}</section>
          </Button>
        </section>
        {downPaymentRequestOpen && (
          <DownPaymentRequest
            open={downPaymentRequestOpen}
            setOpen={setDownPaymentRequestOpen}
            order={order}
            handleDownpaymentSuccess={handleDownpaymentSuccess}
            loading={loading}
            customerDetails={customerDetails}
            isSoldAccount={false}
            isOrderDetails={false}
          ></DownPaymentRequest>
        )}
      </section>
    </section>
  );
};

export { OrderDownPaymentPendingMessage, OrderDownPaymentPendingBox };
